import { DASHBOARD_CONTAINER, PAGE_LOADER } from '../../../../types/types';
import { USER_FORM, USER_STATUS, USER_ROLES } from '../form-portaluser-type';
import { getParameters } from '../../../../helpers/helpers';
import useAuth from '../../../../hooks/auth-hooks';
import { dropdown } from '../../../dropdown';

import { wpGetUserIndividual, awsGetUserIndividual } from '../../../../routes/get-user-individual';

import DisplayExistingPortalUser from './display-portal-user';

/**
 * Handles calling api route function and passing api data to the
 * displayUserInformation function that parses and displays the
 * data.
 * 
 * @returns void
 */
const HandleExistingPortalUser = async () => {
  if ( !USER_FORM.userUpdate ) return;

  const userID = getParameters('userID');
  const level = getParameters('al');

  const { accessType } = useAuth()!;
  const access = accessType === 'E';

  const [ wpUser, awsUser ] = await Promise.all([
    wpGetUserIndividual(userID),
    awsGetUserIndividual(userID, level)
  ]);
  
  PAGE_LOADER.loaderContainer.classList.add('aafp_no-show');
  DASHBOARD_CONTAINER.removeAttribute('style');

  dropdown(USER_STATUS, 'status', 'Status', false, true, access);
  dropdown(USER_ROLES, 'role', 'Role', false, true, access);

  DisplayExistingPortalUser(wpUser.body, awsUser);
}

export default HandleExistingPortalUser;